/**
 * Lazy accessor for the backend client.
 *
 * The generated client statically pulls in auth, realtime (phoenix) and storage
 * modules — roughly 30 KiB of JS that marketing pages never need on first paint.
 * Importing it through this helper keeps it out of the entry chunk; it is fetched
 * on demand from effects and event handlers instead.
 */
export async function getSupabase() {
  const mod = await import("@/integrations/supabase/client");
  return mod.supabase;
}

/** Convenience: current access token (or null) without eagerly loading the client. */
export async function getAccessToken(): Promise<string | null> {
  const supabase = await getSupabase();
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
